export const store = {
  user: {},
  tokens: {},
  mode: "live",
};
